export default [
    { 
        path: '/inscrivez-vous/seances/:id/:date', 
        name: 'meeting_registration_landing',
        component: () => import('/src/pages/PageMeetingRegistration.vue'),
    },
    { 
        path: '/inscrivez-vous/activites-gratuites/:id/:date', 
        name: 'registration_landing_free_event',
        component: () => import('/src/pages/PageFreeEventRegistration.vue'),
    },
    { 
        path: '/inscrivez-vous/service-andc-aide', 
        name: 'registration_landing_andc_help',
        component: () => import('/src/pages/PageRegisterAndcHelp.vue'),
    },
    { 
        path: '/consentement-partenaire-services-andc-aide/confirmation', 
        name: 'partner_agreement_andc_help_confirmation',
        component: () => import('/src/pages/PagePartnerAgreementAndcHelp.vue'),
    },
    { 
        path: '/consentement-partenaire-services-andc-aide/:id', 
        name: 'partner_agreement_andc_help',
        component: () => import('/src/pages/PagePartnerAgreementAndcHelp.vue'),
    },
    {
        path: '/questionnaire-partenaire-services-andc-aide/confirmation',
        name: 'partner_survey_andc_help_confirmation',
        component: () => import('/src/pages/PagePartnerSurveyAndcHelp.vue'),
    },
    {
        path: '/questionnaire-partenaire-services-andc-aide/:id',
        name: 'partner_survey_andc_help',
        component: () => import('/src/pages/PagePartnerSurveyAndcHelp.vue'),
    },
    { 
        path: '/consentement-individuel-services-andc-aide/confirmation', 
        name: 'agreement_individuel_confirmation',
        component: () => import('/src/pages/PageAgreementAndcHelp.vue'),
        meta: { agreementType: 'Individuel', confirmationPath: '/consentement-individuel-services-andc-aide/confirmation' },
    },
    { 
        path: '/consentement-individuel-services-andc-aide/:id', 
        name: 'agreement_individuel',
        component: () => import('/src/pages/PageAgreementAndcHelp.vue'),
        meta: { agreementType: 'Individuel', confirmationPath: '/consentement-individuel-services-andc-aide/confirmation' },
    },
    { 
        path: '/consentement-deuil-services-andc-aide/confirmation', 
        name: 'agreement_deuil_confirmation',
        component: () => import('/src/pages/PageAgreementAndcHelp.vue'),
        meta: { agreementType: 'Deuil par décès', confirmationPath: '/consentement-deuil-services-andc-aide/confirmation' },
    },
    { 
        path: '/consentement-deuil-services-andc-aide/:id', 
        name: 'agreement_deuil',
        component: () => import('/src/pages/PageAgreementAndcHelp.vue'),
        meta: { agreementType: 'Deuil par décès', confirmationPath: '/consentement-deuil-services-andc-aide/confirmation' },
    },
    { 
        path: '/consentement-coaching-services-andc-aide/confirmation', 
        name: 'agreement_coaching_confirmation',
        component: () => import('/src/pages/PageAgreementAndcHelp.vue'),
        meta: { agreementType: 'Coaching - parents/éducateurs', confirmationPath: '/consentement-coaching-services-andc-aide/confirmation' },
    },
    { 
        path: '/consentement-coaching-services-andc-aide/:id', 
        name: 'agreement_coaching',
        component: () => import('/src/pages/PageAgreementAndcHelp.vue'),
        meta: { agreementType: 'Coaching - parents/éducateurs', confirmationPath: '/consentement-coaching-services-andc-aide/confirmation' },
    },
    { 
        path: '/consentement-couple-dyade-services-andc-aide/confirmation', 
        name: 'agreement_couple_dyade_confirmation',
        component: () => import('/src/pages/PageAgreementAndcHelp.vue'),
        meta: { agreementType: 'Couple ou dyade', confirmationPath: '/consentement-couple-dyade-services-andc-aide/confirmation' },
    },
    { 
        path: '/consentement-couple-dyade-services-andc-aide/:id', 
        name: 'agreement_couple_dyade',
        component: () => import('/src/pages/PageAgreementAndcHelp.vue'),
        meta: { agreementType: 'Couple ou dyade', confirmationPath: '/consentement-couple-dyade-services-andc-aide/confirmation' },
    },
    { 
        path: '/consentement-enfant-adolescent-services-andc-aide/confirmation', 
        name: 'agreement_enfant_adolescent_confirmation',
        component: () => import('/src/pages/PageAgreementAndcHelp.vue'),
        meta: { agreementType: 'Enfant ou adolescent', confirmationPath: '/consentement-enfant-adolescent-services-andc-aide/confirmation' },
    },
    { 
        path: '/consentement-enfant-adolescent-services-andc-aide/:id', 
        name: 'agreement_enfant_adolescent',
        component: () => import('/src/pages/PageAgreementAndcHelp.vue'),
        meta: { agreementType: 'Enfant ou adolescent', confirmationPath: '/consentement-enfant-adolescent-services-andc-aide/confirmation' },
    },
];

